import React from "react";
import styles from "./FormattedActionBar.module.scss";
import { Colors } from "@factorearth/component-library/dist/Theme/types";

interface FormattedActionBarProps {
	children: React.ReactElement[];
	color: Colors;
}

// Alright this is very straightforward, just pass in the children, and this will insert the line separator for each one.
// so if things need to be grouped together, put them in a div together or a fragment to make it work.
// See the EditFormTemplate component where we use this component as a reference to integrating this!
// but most importantly.. have fun.
function FormattedActionBar(props: FormattedActionBarProps) {
	const { children, color } = props;

	return (
		<div
			className={styles.action_bar_wrapper}
			style={{
				backgroundColor: color.background.primary,
				color: color.text.primary,
				borderTop: `1px solid ${color.border.secondary}`,
				borderBottom: `1px solid ${color.border.secondary}`,
			}}>
			{children}
		</div>
	);
}

export default FormattedActionBar;
